import { render, staticRenderFns } from "./Misreport_mpswise.vue?vue&type=template&id=81f0940e"
import script from "./Misreport_mpswise.vue?vue&type=script&lang=js"
export * from "./Misreport_mpswise.vue?vue&type=script&lang=js"
import style0 from "./Misreport_mpswise.vue?vue&type=style&index=0&id=81f0940e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports